import * as React from "react";

export interface ProgressProps {
  logo: string;
  message: string;
  title: string;
}

export default class Progress extends React.Component<ProgressProps> {
  render(): JSX.Element {
    const { logo, message, title } = this.props;

    return (
      <div className="taskpane-app taskpane-app--loading">
        <div className="loading-card">
          <img className="loading-card__logo" src={logo} alt={title} />
          <p className="loading-card__eyebrow">Lupp Partner</p>
          <h1 className="loading-card__title">{title}</h1>
          <p className="loading-card__message">{message}</p>
          <div className="loading-card__bar" role="progressbar" aria-label="Lädt …">
            <span className="loading-card__bar-fill" />
          </div>
        </div>
      </div>
    );
  }
}
